export const SEV_COLORS = {
  Critical: '#ff1d62',
  High: '#FF6300',
  Medium: '#FFC303',
  Low: '#0DA109',
  Info: '#A4ACB8',
} as const;

export const SEV_LABELS = ['Critical', 'High', 'Medium', 'Low', 'Info'] as const;

// The trajectory widgets use SEV_COLORS above -- the same classic red / orange / yellow / green
// (grey for Info) every other chart on the dashboard uses. One severity, one colour, everywhere.
//
// Known trade-off, chosen deliberately: this palette does not pass colour-vision checks. Critical
// and High sit at ΔE 13.2 for NORMAL vision (below the 15 floor) and collapse further under
// deuteranopia, and Medium clears only 1.57:1 against a white card. Colour is therefore never the
// only channel in these charts -- every one of them ships direct labels, column totals or a hero
// figure, so a reader who cannot separate two hues still gets the numbers. Do not remove those
// labels to "clean up" a chart; they are what makes this palette usable.

// Brand accent for chart furniture that is NOT a severity -- the range-brush window and handles.
// $teal (#05FFE0) is the app's primary but is far too light to read on a white card, so light mode
// uses $green (#179F8E), the brand's own darker teal, and dark mode uses the teal itself.
export const BRAND_ACCENT_LIGHT = '#179F8E';
export const BRAND_ACCENT_DARK = '#05FFE0';

// The aggregate "total open findings" line is not a severity, so it takes a brand colour rather
// than a step from the severity palette -- drawing "all findings" in Critical red would imply they
// are all critical. $maroon (#C00065) in light, lifted for the dark surface.
export const TOTAL_LINE_LIGHT = '#C00065';
export const TOTAL_LINE_DARK = '#FF6FA8';

// Card surfaces, used as the colour of the 2px gap between stacked segments.
export const CARD_SURFACE_LIGHT = '#FFFFFF';
export const CARD_SURFACE_DARK = '#1E164D';

export const DARK_BASE = '#1E164D';
export const TEAL = '#05FFE0';

export const ALLOWED_STATUSES = [
  'Project Scheduled',
  'In Progress',
  'Report Available',
  'Completed',
];
